module.exports = __webpack_public_path__ + "static/media/crossIcon.ff90dc74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/universal/images/crossIcon.svg
// module id = 996
// module chunks = 0